module.exports = __webpack_public_path__ + "media/stylesheets/images/writer3-9df15aa3ba61ccccc36a59f03efa8539.jpg";